import {yoshinn_help_cn, yoshinn_help_en, yoshinn_help_hk, yoshinn_help_jp} from "@/config/config";


export const languageEnum = [
    {
        id: 101,
        txt: "简体中文",
        key: "cn",
        value: "Chinese",
        packageName: "cn",
    },
    {
        id: 102,
        txt: "Japanese",
        key: "ja",
        value: "Japanese",
        packageName: "ja",
    },
    {
        id: 103,
        txt: "English",
        key: "en",
        value: "English",
        packageName: "en",
    },
    {
        id: 104,
        txt: "繁体中文",
        key: "zh-TW",
        value: "Taiwan",
        packageName: "zh-TW",
    },
]

export function getLanguageValue(key){
    for(var i = 0 ; i < languageEnum.length; i++){
        if(languageEnum[i].key === key){
            return languageEnum[i].value
        }
    }
}

export function getLanguageTxt(key){
    for(var i = 0 ; i < languageEnum.length; i++){
        if(languageEnum[i].key === key){
            return languageEnum[i].txt
        }
    }
}


export function getLanguagePackageName(value){
    for(var i = 0 ; i < languageEnum.length; i++){
        if(languageEnum[i].value === value){
            return languageEnum[i].packageName
        }
    }
}

export function getYoshinnHelpURL(language){
    if(language === "Chinese"){
        return yoshinn_help_cn;
    }
    if(language === "Japanese"){
        return yoshinn_help_jp;
    }
    if(language === "English"){
        return yoshinn_help_en;
    }
    if(language === "Taiwan"){
        return yoshinn_help_hk;
    }
    return yoshinn_help_cn;
}
